module.exports = __webpack_public_path__ + "static/media/fernando.c42b2241.png";